export const GET_CONSENT_FORM_PRODUCT_LIST = "GET_CONSENT_FORM_PRODUCT_LIST"
export const CLEAR_CONSENT_FORM_PRODUCT_LIST ="CLEAR_CONSENT_FORM_PRODUCT_LIST"

export const GET_CONSENT_FORM_MORE_PRODUCT_LIST = "GET_CONSENT_FORM_MORE_PRODUCT_LIST"
export const CLEAR_CONSENT_FORM_MORE_PRODUCT_LIST ="CLEAR_CONSENT_MORE_FORM_PRODUCT_LIST"